import { render } from "./halachot.vue?vue&type=template&id=028eb580"
import script from "./halachot.vue?vue&type=script&lang=js"
export * from "./halachot.vue?vue&type=script&lang=js"

import "./halachot.vue?vue&type=style&index=0&id=028eb580&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__